import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import SeccionCajerosAutomaticos from "../components/CajerosAutomaticos/SeccionCajerosAutomaticos";
import Seo from "../components/Seo";
import { useTranslation } from "react-i18next";

export function CajerosAutomaticos() {
  const { t } = useTranslation();
  const pathByLang = t("seo.atms.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);
  return (
    <div>
      <Seo pageKey="atms" pathByLang={pathByLang} />
      <Navbar />
      <SeccionCajerosAutomaticos />
    </div>
  );
}
